// src/App.js
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import DrawerNavigation from './layouts/DrawerNavigation';

// Import your screens
import HomeScreen from './components/HomeScreen';
import UserProfileScreen from './components/UserProfileScreen';
import OBLTeamScreen from './components/OBLTeamScreen';
import JournalistSearchScreen from './components/JournalistSearchScreen';
import FriendsSearchScreen from './components/FriendsSearchScreen';
import TopicSearchScreen from './components/TopicSearchScreen';
import SubmitScreen from './components/SubmitScreen';
import DirectMessageScreen from './components/DirectMessageScreen';
import LoginScreen from './components/LoginScreen';
import RegistrationScreen from './components/RegistrationScreen';
import LandingHome from "./components/LandingHome";
import CommandCenter from "./components/CommandCenter";
function App() {
  return (
    <Routes>
      {/* Public routes like login/registration */}
      <Route path="/login" element={<LoginScreen />} />
      <Route path="/registration" element={<RegistrationScreen />} />
<Route path="/" element={<LandingHome />} />
<Route path="/command-center" element={<CommandCenter />} />
      {/* Drawer-based routes */}
      <Route element={<DrawerNavigation />}>
        <Route path="/home" element={<HomeScreen />} />
        <Route path="/profile" element={<UserProfileScreen />} />
        <Route path="/team" element={<OBLTeamScreen />} />
        <Route path="/journalist-search" element={<JournalistSearchScreen />} />
        <Route path="/friends-search" element={<FriendsSearchScreen />} />
        <Route path="/topic-search" element={<TopicSearchScreen />} />
        <Route path="/submit" element={<SubmitScreen />} />
        <Route path="/direct-messages" element={<DirectMessageScreen />} />
      </Route>

      {/* Fallback */}
      <Route path="*" element={<LoginScreen />} />
    </Routes>
  );
}

export default App;
